import React from "react";
import "../style/about-us.css";
import aboutImg from "../assets/aboutpic.jpg";
import { FaUserMd, FaBriefcaseMedical, FaClock } from "react-icons/fa";



import Map from "../components/map";

const services = [
  {
    icon: <FaUserMd />,
    title: "Qualified Doctors",
    description:
      "Committed to excellence, our doctors uphold the highest standards of patient care and medical ethics",
  },
  {
    icon: <FaBriefcaseMedical />,
    title: "Trusted Treatment",
    description:
      "Your health is our priority—safe, proven, and personalized care every step of the way to provide you somethinf best.",
  },
  {
    icon: <FaClock />,
    title: "24/7 Services",
    description:
      "Round-the-clock care—our medical team is available 24/7 to support you whenever you need us.",
  },
];

const AboutSection = () => {
  return (
    <section>
      <div className="about-section">
        <div className="container">
          <div className="about-je">
            <div className="about-container">
              <div className="about-left">
                <div className="abt-jp">
                  <span className="about-subtitle">ABOUT US</span><br />
                  <span className="about-title">
                    Welcome To LAXMI <br /> MULTISPECIALITY HOSPITAL
                  </span>
                </div>
                {/* <div className="abt-jp-txt"> */}
                <div className="about-text">
                  At LAXMI MULTISPECIALITY HOSPITAL, we are dedicated to providing
                  world-class healthcare services under one roof, combining advanced
                  medical technology with the expertise of highly qualified doctors
                  and healthcare professionals. As a leading multispecialty hospital,
                  we offer a comprehensive range of medical, surgical, and diagnostic
                  services across numerous specialties.
                </div>

                <div className="about-text">
                  Our state-of-the-art infrastructure features advanced diagnostic
                  tools, cutting-edge treatment facilities, and well-equipped
                  intensive care units designed to handle complex and critical cases.
                  With a patient-centric approach, we strive to deliver personalized
                  care and ensure the well-being of our patients at every step of
                  their health journey.
                </div>

                <div className="about-text">
                  We are committed to innovation, compassion, and excellence in
                  healthcare, continually raising the bar to meet global standards.
                  Whether it’s a routine checkup or a specialized treatment,
                  <strong> LAXMI MULTISPECIALITY HOSPITAL </strong>
                  is here to provide you with seamless and holistic care that
                  prioritizes your health and comfort.
                </div>
                {/* </div> */}
              </div>

              <div className="about-right">
                <img src={aboutImg} alt="Hospital Reception" className="about-img" />
              </div>
            </div>
          </div>
        </div>
      </div>








      {/* Services Cards Section */}
      <div className="service-containers">
        <div className="container">
          <div className="abt-ser-je">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>


      <div className="map">
        <Map />
      </div>
    </section>
  );
};

export default AboutSection;
